import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPsap } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { organizationSelector } from '@rsos/reduxDataStore/src/features/selectors/organizationSelector';
import { fetchUser } from '@rsos/sinatra';
import { SettingsManagementState } from '../reducers';
import { SettingsManagementDispatch } from '../store';

export type AppSettingsState = {
  initializing: boolean;
  initialized: boolean;
  initError?: string | null;
};

const initialState: AppSettingsState = {
  initializing: true,
  initialized: false,
  initError: null,
};

export const initialize = createAsyncThunk<
  void,
  void,
  { state: SettingsManagementState; dispatch: SettingsManagementDispatch }
>('appSettings/initialize', async (_, { dispatch, getState }) => {
  const isLoggedIn = getState().sinatra.user.isLoggedIn;
  try {
    await dispatch(fetchUser());
    const orgName = organizationSelector(getState())?.name;
    dispatch(fetchPsap(`/psaps/${orgName}`));
  } catch (err) {
    if (isLoggedIn) {
      if (err) {
        throw err;
      }
    }
    window.location.replace('/');
  }
});

const appSlice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(initialize.pending, state => {
        state.initializing = true;
        state.initialized = false;
        state.initError = null;
      })
      .addCase(initialize.fulfilled, state => {
        state.initializing = false;
        state.initialized = true;
        state.initError = null;
      })
      .addCase(initialize.rejected, (state, { error = {} }) => {
        state.initializing = false;
        state.initialized = false;
        state.initError = error.message;
      });
  },
});

export function selectAppSettingsState(state: {
  appSettings: AppSettingsState;
}) {
  return state.appSettings;
}

export const appReducer = appSlice.reducer;
export default appReducer;
